var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: ["callback-block", "callback-block--" + _vm.theme],
      attrs: { id: _vm.idFormblock },
    },
    [
      _c("content-wrapper-block", { staticClass: "callback-block__row" }, [
        _c("div", { staticClass: "callback-block__left" }, [
          _c("div", { staticClass: "callback-block__title" }, [
            _vm._v(" " + _vm._s(_vm.title) + " "),
          ]),
          _c("div", { staticClass: "callback-block__subtitle" }, [
            _vm._v(" " + _vm._s(_vm.subtitle) + " "),
          ]),
          _c(
            "form",
            {
              ref: "callback-form",
              staticClass: "callback-block__form callback-form",
              attrs: { id: _vm.id, method: "POST" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "callback-form__row" }, [
                _c(
                  "div",
                  { staticClass: "callback-form__col col-3" },
                  [
                    _c("ui-input", {
                      ref: "form-name",
                      attrs: {
                        id: _vm.id + "-name",
                        hint: "Введите корректные данные",
                        dark: _vm.theme === "black" ? true : false,
                        "placeholder-value": "Имя *",
                        required: "",
                      },
                      model: {
                        value: _vm.name,
                        callback: function ($$v) {
                          _vm.name = $$v
                        },
                        expression: "name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "callback-form__col col-3" },
                  [
                    _c("ui-input", {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: "+7 (###) ###-##-##",
                          expression: "'+7 (###) ###-##-##'",
                        },
                      ],
                      ref: "form-phone",
                      attrs: {
                        id: _vm.id + "-phone",
                        type: "tel",
                        dark: _vm.theme === "black" ? true : false,
                        hint: "Введите корректный номер телефона",
                        "placeholder-value": "телефон *",
                        required: "",
                      },
                      model: {
                        value: _vm.phone,
                        callback: function ($$v) {
                          _vm.phone = $$v
                        },
                        expression: "phone",
                      },
                    }),
                    !_vm.isPhoneValid
                      ? _c("div", { staticClass: "form-phone_valid" }, [
                          _vm._v(" Введите корректный номер телефона "),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "callback-form__col col-3" },
                  [
                    _c("ui-input", {
                      ref: "form-email",
                      attrs: {
                        id: _vm.id + "-email",
                        type: "email",
                        hint: "Введите корректный email",
                        dark: _vm.theme === "black" ? true : false,
                        error: !_vm.isEmailValid,
                        "placeholder-value": "email",
                      },
                      model: {
                        value: _vm.email,
                        callback: function ($$v) {
                          _vm.email = $$v
                        },
                        expression: "email",
                      },
                    }),
                    !_vm.isEmailValid
                      ? _c("div", { staticClass: "form-email_valid" }, [
                          _vm._v(" Введите корректный email "),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.hidden,
                      expression: "hidden",
                    },
                  ],
                  attrs: { name: "ch" },
                  domProps: { value: _vm.hidden },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.hidden = $event.target.value
                    },
                  },
                }),
                _c("div", {
                  ref: "captcha",
                  staticClass: "callback-form__captcha",
                }),
                _c(
                  "div",
                  { staticClass: "callback-form__col" },
                  [
                    _c(
                      "ui-button",
                      {
                        attrs: {
                          type: "submit",
                          outline: _vm.theme === "black" ? false : true,
                          loading: _vm.loading,
                        },
                        on: { click: _vm.submitForm },
                      },
                      [_vm._v(" Отправить ")]
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "callback-form__email-info" }, [
                _vm._v(
                  "Подпишитесь, чтобы не пропустить актуальные предложения и акции!"
                ),
              ]),
              _vm.enableAgreement
                ? _c("div", { staticClass: "callback-form__row agreement" }, [
                    _c(
                      "div",
                      { staticClass: "callback-form__col" },
                      [
                        _c("ui-input", {
                          ref: "form-agreement",
                          staticClass: "row",
                          attrs: {
                            id: _vm.id + "-agreement",
                            type: "checkbox",
                            dark: _vm.theme === "black" ? true : false,
                            required: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      [
                                        _vm._v("Ознакомлен(а) с "),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: "/Политика_обработки_персональных_данных.pdf",
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "Политикой обработки персональных данных"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" и даю "),
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: { name: "DataConsentPage" },
                                              target: "_blank",
                                            },
                                          },
                                          [_vm._v("согласие")]
                                        ),
                                        _vm._v(" на их обработку. "),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            297006950
                          ),
                          model: {
                            value: _vm.checkbox,
                            callback: function ($$v) {
                              _vm.checkbox = $$v
                            },
                            expression: "checkbox",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "callback-form__col" },
                      [
                        _c("ui-input", {
                          ref: "form-agreement-promotion",
                          staticClass: "row",
                          attrs: {
                            id: _vm.id + "-promotion",
                            type: "checkbox",
                            dark: _vm.theme === "black" ? true : false,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      [
                                        _vm._v("Я даю согласие на получение "),
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: { name: "PromotionPage" },
                                              target: "_blank",
                                            },
                                          },
                                          [_vm._v("рекламных рассылок")]
                                        ),
                                        _vm._v(". "),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            340633291
                          ),
                          model: {
                            value: _vm.checkboxPromotion,
                            callback: function ($$v) {
                              _vm.checkboxPromotion = $$v
                            },
                            expression: "checkboxPromotion",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }